module.exports = __webpack_public_path__ + "assets/img/Type BS (14).9131690f.jpg";